import { Pipe, PipeTransform } from '@angular/core';

import { FieldStatistics } from '../providers/field-statistics.service';
import { Utils } from '../utils/utils';
@Pipe({ name: 'conversionPipe', pure: true, standalone: false })
export class ConversionPipe implements PipeTransform {
  transform(
    fieldName: any,
    fieldStatistics: { [field: string]: FieldStatistics }
  ): number | string {
    if (fieldStatistics[fieldName]) {
      return Utils.conversionRateFor(fieldName, fieldStatistics);
    }
    return '??';
  }
}
